import React from "react";
import LoadingModal from "../Common/LoadingModal";

const LoadingOverlay = ({ isSubmitting }) => {
  if (!isSubmitting) return null;

  return <LoadingModal message="Processing Your Order..." />;
};

export default LoadingOverlay;
